import styled from 'styled-components';

export const Container = styled.ul`
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 15rem;
    height: 300px;
    overflow-y: scroll;

    & > *:not(:last-child) {
        margin-bottom: 1.25rem;
    }
`;
